import axios from 'axios'
import { useCallback, useState } from 'react'
import { BYPASS_RECAPTCHA } from '../settings'

type RecaptchaAssessment = {
  tokenProperties?: {
    valid?: boolean
  }
}

export const useRecaptcha = () => {
  const [valid, setValid] = useState(BYPASS_RECAPTCHA)

  const validateCaptchaToken = useCallback(async (token: string) => {
    const assessment = await axios<RecaptchaAssessment>({
      url: 'https://recaptchaenterprise.googleapis.com/v1/projects/uat-clever-clinic/assessments',
      method: 'post',
      responseType: 'json',
      params: { key: process.env.REACT_APP_GOOGLE_API_KEY },
      data: {
        event: {
          token,
          siteKey: process.env.REACT_APP_GOOGLE_SITE_KEY,
        },
      },
    })
      .then(({ data }) => data)
      .catch(() => undefined)

    setValid(assessment?.tokenProperties?.valid ?? false)
  }, [])

  return {
    valid,
    validateCaptchaToken,
  }
}
